import { useIssueResolver } from 'hooks/useIssueResolver';
import { useCurrentPartner } from 'services/repositories/partners/partners';
import { IssueResolverType, MessageV2DTO, PartnerDTO, UserDTO } from 'support/types';

export const canEditMessageByCurrentUser = (
  message: MessageV2DTO | undefined,
  currentUser: UserDTO | undefined,
  currentPartner: PartnerDTO | undefined,
): boolean => {
  const isIssueResolver =
    useIssueResolver.getResolverType(message?.issue_resolver_id, currentPartner) === IssueResolverType.CURRENT_PARTNER;
  return isIssueResolver || Boolean(currentUser?.isAdmin);
};

export const useCanEditMessage = (message: MessageV2DTO | undefined, currentUser: UserDTO | undefined): boolean => {
  const { data: currentPartner } = useCurrentPartner();
  return canEditMessageByCurrentUser(message, currentUser, currentPartner);
};
